module.exports = __webpack_public_path__ + "static/media/checkout_2.9612c625.png";